exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description-area[data-v-75a4b994]{min-height:40%}.about-ch[data-v-75a4b994]{font-size:1.1rem}", ""]);

// exports
